import React from "react";
import PropTypes from "prop-types";
import "./index.scss";
function Select(Props) {
  const { handleChange, options, name, selectedValue, disabled, required, labelClass, label} = Props;
  return (
    <div className="">
      <label className={labelClass}>{label}</label>
      <select
      disabled={disabled}
        className={
          selectedValue
            ? "form-select select_title"
            : "form-select select_title select_placeholder"
        }
        onChange={handleChange}
        name={name}
        value={selectedValue}
        required={required}
      >
        {options.map((val, ind) => (
          <option hidden={ind === 0 && name !== "serviceOffered"} value={val} key={val}>
            {val}
          </option>
        ))}
      </select>
    </div>
  );
}

Select.propTypes = {
  handleChange: PropTypes.func,
  selectedvalue: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string,
  selectedValue: PropTypes.string,
  disabled:PropTypes.bool,
  required:PropTypes.bool,
  labelClass: PropTypes.string,
  label: PropTypes.string
};

Select.defaultProps = {
  handleChange: () => null,
  selectedvalue: "",
  options: [],
  name: "",
  selectedValue: "",
  disabled:false,
  required:false,
  labelClass: "hidden",
  label: "label"
};

export default Select;
